import api from '../../api';

const path = `/search`;

const getServicesListRequest = params =>
    api.get(`${path}/services/get`, {
        params,
    });

const getPlacementListRequest = params =>
    api.get(`${path}/placement/get`, {
        params,
    });

const getPartsListRequest = params =>
    api.get(`${path}/parts/get`, {
        params,
    });

export { getServicesListRequest, getPlacementListRequest, getPartsListRequest };
